import React, { useMemo } from 'react';

// DEPENDENCIES
import { useNavigate, useParams, useLocation } from 'react-router-dom';

// GLOBAL COMPONENTS
import Button from 'core/tools/Button';

// GLOBAL METHODS
import { makePath } from 'functions';

// GLOBAL VARIABLES
import { INTERFACE, RECORD } from 'pathnames.js';

// STYLE
import styles from './pagination.module.scss';

// MAIN COMPONENT
const Pagination = () => {

  // REACT ROUTER
  const navigate = useNavigate();
  const location = useLocation();
  const { recordID } = useParams();

  // MEMOS
  const pagination = useMemo(
    () => {
      if (location.state?.daily_sales_inventory_id_list) {
        const inventoryKeys = location.state.daily_sales_inventory_id_list.split(',');
        const currentID = inventoryKeys.findIndex(id => id === String(recordID));
        const total = inventoryKeys.length;
  
        return {
          total,
          currentIndex: currentID + 1,
          prevID: currentID > 0 ? inventoryKeys[currentID - 1] : null,
          nextID: currentID + 1 < total ? inventoryKeys[currentID + 1] : null
        };
      } else {
        return null;
      }
    },
    [location.state, recordID]
  )

  // RENDER
  return !pagination ? null : (<>
    {pagination.prevID> 1 && (
      <Button
        label="Previous Vehicle"
        icon="arrow-left"
        onClick={() => {
          navigate(makePath(INTERFACE.inventory, RECORD.view, pagination.prevID), {
            state: location.state
          });
        }}
        outline
        size="sm"
      />
    )}
    <h5 className={styles.text}>
      {pagination.currentIndex} of {pagination.total}
    </h5>
    {pagination.nextID && (
      <Button
        label="Next Vehicle"
        icon="arrow-right"
        onClick={() => {
          navigate(makePath(INTERFACE.inventory, RECORD.view, pagination.nextID), {
            state: location.state
          });
        }}
        outline
        size="sm"
      />
    )}
  </>);
};

// EXPORT
export default Pagination;
